import styled from 'styled-components';
import { Checkbox as CuiCheckbox } from '@chegg-ui/checkbox';
import { spacing, font } from '@chegg-ui/theme';
export var TermsAndPromosDiv = styled.div.withConfig({
  componentId: "sc-yhsr4a-0"
})(["margin-block:", ";"], spacing.px16);
export var Checkbox = styled(CuiCheckbox).withConfig({
  componentId: "sc-yhsr4a-1"
})(["margin-block-end:", ";font-size:", ";line-height:", ";"], spacing.px16, font.size.px12, font.lineHeight.md);